import { Link } from "react-router-dom";

export const Wordmark = ({ className = "" }) => (
  <Link to="/" data-testid="middle-wordmark" className={`group inline-flex items-center gap-2 ${className}`} aria-label="Middle home">
    <span className="relative flex h-7 w-7 items-center justify-center">
      <span className="absolute h-7 w-7 rounded-full border-[1.5px] border-slate-900" />
      <span className="h-2 w-2 rounded-full bg-[hsl(var(--social))] transition-transform duration-300 group-hover:scale-125" />
    </span>
    <span className="font-serif text-[1.45rem] font-medium tracking-tight text-slate-900">middle</span>
  </Link>
);
